import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

export const CampaignCreateModalLoader = () =>
  import(/* webpackChunkName: "4-feat-campaign-create" */ './CampaignCreateModalBoundary');

export default lazyLoadOnRender({ loader: CampaignCreateModalLoader });
